const { writeFile } = require("fs");
const { join } = require("path");

const pkgPath = join(process.cwd(), "./package.json");
const isNodeRuntime = () => {
  return typeof window === "undefined";
};

const genTimestamp = () => {
  const now = new Date();
  return now.toLocaleString();
};

const updatePackageInfo = timestamp => {
  return new Promise((resolve, reject) => {
    const oldInfo = require(pkgPath);
    const newInfo = JSON.parse(JSON.stringify(oldInfo));
    newInfo.buildTimeStamp = timestamp;
    writeFile(pkgPath, JSON.stringify(newInfo, "", 2), err => {
      if (err) {
        reject(err);
      }
      resolve();
    });
  });
};

const main = async () => {
  try {
    // 避免代码在浏览器运行
    if (isNodeRuntime()) {
      const timestamp = genTimestamp();
      await updatePackageInfo(timestamp);
      console.log("⚡ 项目打包时间戳同步成功.");
    }
  } catch (error) {
    console.log("💥 项目打包时间戳同步失败.", error);
  }
};

/**
 * 将项目打包时间戳注入到window对象，方便查看线上服务是否更新成功.
 */
const injectBuildTimeStampToWindow = () => {
  const pkgInfo = require("../package.json");
  window.buildTimeStamp = pkgInfo.buildTimeStamp;
};

module.exports = {
  injectBuildTimeStampToWindow
};

main();
